import { render } from "./PageComponentSelector.vue?vue&type=template&id=61e5cbfc&ts=true"
import script from "./pageComponentSelector?vue&type=script&lang=ts"
export * from "./pageComponentSelector?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__